import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * A new build has been installed and is already in control.
 *
 * The worker registers with autoUpdate and claims clients immediately, so the
 * code on disk is new but the running tab is still the old one. This is only
 * an invitation to reload -- not a gate -- so it sits at the bottom and can be
 * ignored until you are not mid-departure-check.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]"
    >
      <div className="bg-raised border-line mx-auto flex max-w-lg items-center gap-3 rounded-xl border p-3 shadow-lg">
        <span className="flex-1 text-[15px]">Ny version tillgänglig.</span>
        <button
          type="button"
          onClick={() => void updateServiceWorker(true)}
          className="bg-accent text-raised min-h-9 rounded-lg px-3 text-[15px] font-semibold"
        >
          Ladda om
        </button>
        <button
          type="button"
          onClick={() => setNeedRefresh(false)}
          aria-label="Stäng"
          className="text-faint min-h-9 px-2 text-[15px]"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
